module.exports = __webpack_public_path__ + "static/img/llzf.38f3451.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/llzf.png
// module id = 3Ps1
// module chunks = 1